import React, {useState} from "react";
import {Tooltip} from "antd";
import {ThunderboltFilled, InsertRowAboveOutlined, ScheduleOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {
    TableContainer,
    ActionButtons,
    ProgressWrapper,
    ClickableSpan
} from "./ResponsiveDataTable.styles";
import {useHistory} from "react-router-dom";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import {truncateString} from "../../../../utils/helpers";
import {PoolCouriersDrawer} from "../poolCouriersDrawer/PoolCouriersDrawer";
import {EmptyMessage} from "../../../_defaultComponents/EmptyMessage/EmptyMessage";

const TABLE_PREFIX = "poolTable";

export const courierTypeMapping = {
    inSlot: {label: "Slot Seçen Kuryeler", value: "inSlot"},
    unAvailable: {label: "Meşgul Kuryeler", value: "unAvailable"},
    active: {label: "Aktif Kuryeler", value: "active"},
    onDelivery: {label: "Siparişteki Kuryeler", value: "onDelivery"},
    available: {label: "Müsait Kuryeler", value: "available"}
};
const ResponsiveDataTable = ({data = [], loading, currentPage, setCurrentPage, dataCount}) => {
    const {t} = useTranslation(["pools"]);
    const history = useHistory();
    const [selectedPoolId, setSelectedPoolId] = useState(undefined);
    const [selectedType, setSelectedType] = useState(undefined);
    const [selectedPoolName, setSelectedPoolName] = useState(undefined);

    const translateColorByProgress = progress => {
        //smooth transition between colors
        const endColor = [255, 0, 0];
        const startColor = [140, 158, 51];
        const r = Math.floor(startColor[0] + (endColor[0] - startColor[0]) * progress * 0.01);
        const g = Math.floor(startColor[1] + (endColor[1] - startColor[1]) * progress * 0.01);
        const b = Math.floor(startColor[2] + (endColor[2] - startColor[2]) * progress * 0.01);
        return `rgb(${r},${g},${b})
    `;
    };

    const renderActionButtons = id => {
        const permisions = {
            showForecastTable: true,
            showSlotTable: true,
            showShifts: true
        };
        return (
            <ActionButtons>
                {permisions.showForecastTable && (
                    <Tooltip title={"Forecast"}>
                        <CustomButton
                            data-testid="poolShiftStatDetailButton"
                            onClick={() => history.push(`/pools/${id}/daily-forecasts`)}
                            icon={<ThunderboltFilled />}
                        ></CustomButton>
                    </Tooltip>
                )}
                {permisions.showSlotTable && (
                    <Tooltip title={"Slot"}>
                        <CustomButton
                            data-testid="poolShiftStatDetailButton"
                            onClick={() => history.push(`/pools/${id}/daily-slots`)}
                            icon={<InsertRowAboveOutlined />}
                        ></CustomButton>
                    </Tooltip>
                )}
                {permisions.showShifts && (
                    <Tooltip title={"Vardiyalar"}>
                        <CustomButton
                            data-testid="poolShiftStatDetailButton"
                            onClick={() => history.push(`/pools/courier-shifts?poolId=${id}`)}
                            icon={<ScheduleOutlined />}
                        ></CustomButton>
                    </Tooltip>
                )}
            </ActionButtons>
        );
    };

    const onSelectType = ({poolId, type, poolName = ""}) => {
        setSelectedPoolId(poolId);
        setSelectedType(type);
        setSelectedPoolName(poolName);
    };
    const onDrawerClose = () => {
        setSelectedPoolId(undefined);
        setSelectedType(undefined);
        setSelectedPoolName(undefined);
    };

    return (
        <>
            <TableContainer
                className={TABLE_PREFIX}
                pagination={
                    false /* {
                    total: dataCount,
                    current: currentPage,
                    onChange: async page => {
                        setCurrentPage(page);
                    },
                    hideOnSinglePage: true,
                    showSizeChanger: false
                } */
                }
                rowKey="_id"
                rowClassName="hello"
                dataSource={data}
                data-testid="poolDataTable"
                size="small"
                scroll={{x: "max-content"}}
                locale={{
                    emptyText: <EmptyMessage />
                }}
                //loading={loading}
            >
                <TableContainer.Column
                    className="pool-available-rates-column"
                    dataIndex="name"
                    title={t("fields.poolRegion", {ns: "pools"})}
                    fixed="left"
                    width={150}
                    render={name => (
                        <span
                            data-testid="poolName"
                            data-label={`${t("fields.poolRegion", {ns: "pools"})}:`}
                        >
                            <Tooltip title={name}>{truncateString(`${name}`, 30)}</Tooltip>
                        </span>
                    )}
                    sorter={(a, b) => a.name.localeCompare(b.name, "tr")}
                    defaultSortOrder={"ascend"}
                />
                <TableContainer.Column
                    width={50}
                    className="pool-available-rates-column"
                    dataIndex="availableRate"
                    title={
                        <>
                            Anlık Havuz <br />
                            Yoğunluğu(%)
                        </>
                    }
                    align="center"
                    sorter={(a, b) => a.availableRate - b.availableRate}
                    render={(availableRate = 0, stats) => {
                        return (
                            <span data-testid="poolAvailableRate" data-label={"Yoğunluk Oranı(%):"}>
                                <Tooltip title={`Yoğunluk Oranı : ${availableRate}%`}>
                                    <b style={{color: translateColorByProgress(availableRate)}}>
                                        {availableRate}%
                                    </b>
                                </Tooltip>
                            </span>
                        );
                    }}
                />
                <TableContainer.Column
                    width={150}
                    className="pool-available-rates-column"
                    align="center"
                    dataIndex="queuedDeliveryCount"
                    title={
                        <>
                            Kuyrukta Bekleyen
                            <br />
                            Sipariş Sayısı
                        </>
                    }
                    sorter={(a, b) => a.queuedDeliveryCount - b.queuedDeliveryCount}
                    render={(queuedDeliveryCount = 0, stats) => (
                        <span
                            data-testid="poolCouriersCount"
                            data-label={"Kuyrukta Bekleyen Sipariş Sayısı:"}
                        >
                            <Tooltip title={"Kuyrukta Bekleyen Sipariş Sayısı"}>
                                {queuedDeliveryCount}
                            </Tooltip>
                        </span>
                    )}
                />
                <TableContainer.Column
                    width={100}
                    className="pool-available-rates-column"
                    align="center"
                    dataIndex="inSlotCouriersCount"
                    title={
                        <>
                            Slot Seçen
                            <br />
                            Kurye Sayısı
                        </>
                    }
                    sorter={(a, b) => a.inSlotCouriersCount - b.inSlotCouriersCount}
                    render={(inSlotCouriersCount = 0, stats) => (
                        <ClickableSpan
                            data-testid="poolInSlotCouriersCount"
                            data-label={"Slot Seçen Kurye Sayısı:"}
                            onClick={() =>
                                onSelectType({
                                    poolId: stats._id,
                                    type: courierTypeMapping.inSlot.value,
                                    poolName: stats?.name
                                })
                            }
                        >
                            <Tooltip title={"Slot Seçen Kurye Sayısı"}>
                                {inSlotCouriersCount}
                            </Tooltip>
                        </ClickableSpan>
                    )}
                />
                <TableContainer.Column
                    width={100}
                    className="pool-available-rates-column"
                    align="center"
                    dataIndex="unAvailableCouriersCount"
                    title={
                        <>
                            Meşgul Kurye
                            <br />
                            Sayısı
                        </>
                    }
                    sorter={(a, b) => a.unAvailableCouriersCount - b.unAvailableCouriersCount}
                    render={(unAvailableCouriersCount = 0, stats) => (
                        <ClickableSpan
                            data-testid="poolUnAvailableCouriersCount"
                            data-label={"Meşgul Kurye Sayısı:"}
                            onClick={() =>
                                onSelectType({
                                    poolId: stats._id,
                                    type: courierTypeMapping.unAvailable.value,
                                    poolName: stats?.name
                                })
                            }
                        >
                            <Tooltip title={"Meşgul Kurye Sayısı"}>
                                {unAvailableCouriersCount}
                            </Tooltip>
                        </ClickableSpan>
                    )}
                />
                <TableContainer.Column
                    width={75}
                    className="pool-available-rates-column"
                    align="center"
                    dataIndex="activeCouriersCount"
                    title={
                        <>
                            Aktif Kurye
                            <br /> Sayısı
                        </>
                    }
                    sorter={(a, b) => a.activeCouriersCount - b.activeCouriersCount}
                    render={(activeCouriersCount = 0, stats) => (
                        <ClickableSpan
                            data-testid="poolActiveCouriersCount"
                            data-label={"Aktif Kurye Sayısı:"}
                            onClick={() =>
                                onSelectType({
                                    poolId: stats._id,
                                    type: courierTypeMapping.active.value,
                                    poolName: stats?.name
                                })
                            }
                        >
                            <Tooltip title={"Aktif Kurye Sayısı"}>{activeCouriersCount}</Tooltip>
                        </ClickableSpan>
                    )}
                />
                <TableContainer.Column
                    width={100}
                    className="pool-available-rates-column"
                    align="center"
                    dataIndex="onDeliveryCouriersCount"
                    title={
                        <>
                            Siparişteki
                            <br />
                            Kurye Sayısı
                        </>
                    }
                    sorter={(a, b) => a.onDeliveryCouriersCount - b.onDeliveryCouriersCount}
                    render={(onDeliveryCouriersCount = 0, stats) => (
                        <ClickableSpan
                            data-testid="poolOnDeliveryCouriersCount"
                            data-label={"Siparişteki Kurye Sayısı:"}
                            onClick={() =>
                                onSelectType({
                                    poolId: stats._id,
                                    type: courierTypeMapping.onDelivery.value,
                                    poolName: stats?.name
                                })
                            }
                        >
                            <Tooltip title={"Siparişteki Kurye Sayısı"}>
                                {onDeliveryCouriersCount}
                            </Tooltip>
                        </ClickableSpan>
                    )}
                />
                <TableContainer.Column
                    width={100}
                    className="pool-available-rates-column"
                    align="center"
                    dataIndex="availableCouriersCount"
                    title={
                        <>
                            Müsait Kurye
                            <br />
                            Sayısı
                        </>
                    }
                    sorter={(a, b) => a.availableCouriersCount - b.availableCouriersCount}
                    render={(availableCouriersCount = 0, stats) => (
                        <ClickableSpan
                            data-testid="poolAvailableCouriersCount"
                            data-label={"Müsait Kurye Sayısı:"}
                            onClick={() =>
                                onSelectType({
                                    poolId: stats._id,
                                    type: courierTypeMapping.available.value,
                                    poolName: stats?.name
                                })
                            }
                        >
                            <Tooltip title={"Müsait Kurye Sayısı"}>
                                {availableCouriersCount}
                            </Tooltip>
                        </ClickableSpan>
                    )}
                />
                <TableContainer.Column
                    width={50}
                    className="pool-available-rates-column"
                    align="center"
                    dataIndex="slotLimit"
                    title={"Slot Limiti"}
                    sorter={(a, b) => a.slotLimit - b.slotLimit}
                    render={(slotLimit = 0, stats) => (
                        <span data-testid="slotLimit" data-label={"Slot Limiti:"}>
                            <Tooltip title={"Slot Limiti"}>{slotLimit}</Tooltip>
                        </span>
                    )}
                />
                <TableContainer.Column
                    width={100}
                    className="pool-available-rates-column"
                    align="center"
                    dataIndex="poolCouriersCount"
                    title={
                        <>
                            Havuz Kurye
                            <br /> Sayısı
                        </>
                    }
                    sorter={(a, b) => a.poolCouriersCount - b.poolCouriersCount}
                    render={(poolCouriersCount = 0, stats) => (
                        <span data-testid="poolCouriersCount" data-label={"Havuz Kurye Sayısı:"}>
                            <Tooltip title={"Havuz Kurye Sayısı"}>{poolCouriersCount}</Tooltip>
                        </span>
                    )}
                />
                <TableContainer.Column
                    width={80}
                    className="pool-available-rates-column"
                    dataIndex="slotRate"
                    title={
                        <>
                            Slot Seçim
                            <br /> Oranı(%)
                        </>
                    }
                    align="center"
                    sorter={(a, b) => a.slotRate - b.slotRate}
                    render={(slotRate = 0, stats) => (
                        <span data-testid="slotRate" data-label={"Slot Seçim Oranı(%):"}>
                            {/*TODO Mobilde sadece sayı yazmalı !!!!!!!!!*/}
                            <Tooltip
                                title={`Slot Seçim Oranı(%) : ${parseFloat(slotRate).toFixed(0)}%`}
                            >
                                <b>{parseFloat(slotRate).toFixed(0)}%</b>
                            </Tooltip>
                        </span>
                    )}
                />
                <TableContainer.Column
                    className="pool-available-rates-column"
                    dataIndex="integrationType"
                    title={t("filters.integrationType", {ns: "common"})}
                    width={150}
                    render={integrationType => (
                        <span
                            data-testid="integrationType"
                            data-label={t("filters.integrationType", {ns: "common"})}
                        >
                            <Tooltip title={integrationType}>
                                {integrationType === "dedicated"
                                    ? "Dedike"
                                    : integrationType === "pool"
                                    ? "Havuz"
                                    : integrationType === "dedicatedIntegration"
                                    ? "Dedike Entegrasyon"
                                    : "-"}
                            </Tooltip>
                        </span>
                    )}
                />
                <TableContainer.Column
                    className="pool-available-rates-column"
                    align="center"
                    width={140}
                    title={t("actions.action", {ns: "common"})}
                    dataIndex="_id"
                    render={renderActionButtons}
                />
                <TableContainer.Column
                    width={150}
                    className="pool-available-rates-column"
                    align="center"
                    dataIndex="activeDeliveryCount"
                    title={
                        <>
                            Aktif Sipariş
                            <br />
                            Sayısı
                        </>
                    }
                    sorter={(a, b) => a.activeDeliveryCount - b.activeDeliveryCount}
                    render={(activeDeliveryCount = 0, stats) => (
                        <span data-testid="poolCouriersCount" data-label={"Aktif Sipariş Sayısı:"}>
                            <Tooltip title={"Aktif Sipariş Sayısı"}>{activeDeliveryCount}</Tooltip>
                        </span>
                    )}
                />
                <TableContainer.Column
                    width={100}
                    className="pool-available-rates-column"
                    align="center"
                    dataIndex="deliveredCount"
                    title={
                        <>
                            Teslim Edilen
                            <br /> Sipariş Sayısı
                        </>
                    }
                    sorter={(a, b) => a.deliveredCount - b.deliveredCount}
                    render={(deliveredCount = 0, stats) => (
                        <span
                            data-testid="deliveredCount"
                            data-label={"Teslim Edilen Sipariş Sayısı:"}
                        >
                            <Tooltip title={"Teslim Edilen Sipariş Sayısı"}>
                                {deliveredCount}
                            </Tooltip>
                        </span>
                    )}
                />
                <TableContainer.Column
                    width={100}
                    className="pool-available-rates-column"
                    align="center"
                    dataIndex="canceledCount"
                    title={
                        <>
                            İptal Edilen
                            <br /> Sipariş Sayısı
                        </>
                    }
                    sorter={(a, b) => a.canceledCount - b.canceledCount}
                    render={(canceledCount = 0, stats) => (
                        <span
                            data-testid="canceledCount"
                            data-label={"İptal Edilen Sipariş Sayısı"}
                        >
                            <Tooltip title={"İptal Edilen Sipariş Sayısı"}>{canceledCount}</Tooltip>
                        </span>
                    )}
                />
            </TableContainer>
            <PoolCouriersDrawer
                onClose={onDrawerClose}
                poolId={selectedPoolId}
                type={selectedType}
                poolName={selectedPoolName}
                visible={selectedPoolId !== undefined && selectedType !== undefined}
            />
        </>
    );
};

export default ResponsiveDataTable;
